import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import SelectAllChecksGroup from '../../../../../reusable/Form/SelectAllChecksGroup';
import RiskShape from './../DashboardFilters.jsx';

class RiskLevelFilter extends Component {

    static propTypes = {
        risk: PropTypes.shape(RiskShape).isRequired,
        switchRisk: PropTypes.func.isRequired
    }

    static defaultProps = {
        risk: {
            high: true,
            medium: true,
            low: true
        }
    }

    constructor(props) {
        super(props);

        this.filterByRisk = this.filterByRisk.bind(this);
    }

    filterByRisk(options) {
        let newRisk = Object.assign({}, this.props.risk);

        for (let i in options) {
            newRisk[options[i].name] = options[i].value
        }

        this.props.switchRisk(newRisk);
    };

    /**
     * Inbound conversion: Returns "any_level" if all options true, otherwise returns the one that is true
     * @returns {string}
     */
    getValue() {
        return this.props.risk.high && this.props.risk.medium && this.props.risk.low ? "any_level" :
            this.props.risk.high ? "high" : this.props.risk.medium ? "medium" : this.props.risk.low ? "low" : "any_level"
    }

    render() {
        const options = [
            {
                name: "high",
                value: this.props.risk.high,
                label: <FormattedMessage id="General_CoreFunctionality_UIText_general.levelSelect.high"  />
            },
            {
                name: "medium",
                value: this.props.risk.medium,
                label: <FormattedMessage id="General_CoreFunctionality_UIText_general.levelSelect.medium" />
            },
            {
                name: "low",
                value: this.props.risk.low,
                label: <FormattedMessage id="General_CoreFunctionality_UIText_general.levelSelect.low" />
            }
        ]
        return <SelectAllChecksGroup value={this.getValue()}
                           onChange={this.filterByRisk}
                           options={options}
                           selectAll={this.props.intl.formatMessage({ id: "Dashboard_CoreFunctionality_UIText_dashboard.selectAll" })}
                           classNames="notranslate risk-levels-filter"/>
    }
}

export default injectIntl(RiskLevelFilter);


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/FilterPod/RiskLevel.filter.jsx